import { defineStore } from 'pinia';

import type { DeductionDocument } from '@stuut/api/models';

interface State {
  deductionDocuments: DeductionDocument[];
}

export const useDeductionDocuments = defineStore('deductionDocuments', {
  getters: {
    getById: (state) => {
      return (deductionDocumentId: string) =>
        state.deductionDocuments.find(
          (deductionDocument) => deductionDocument.id === deductionDocumentId,
        ) as DeductionDocument | undefined;
    },
  },
  state: (): State => ({
    deductionDocuments: [],
  }),
});

export default useDeductionDocuments;
